export default __webpack_public_path__ + "static/media/checkbox_checked.7736266a.svg";